import { render, staticRenderFns } from "./BirthdaysHome.vue?vue&type=template&id=569a810d&scoped=true"
import script from "./BirthdaysHome.vue?vue&type=script&lang=js"
export * from "./BirthdaysHome.vue?vue&type=script&lang=js"
import style0 from "./BirthdaysHome.vue?vue&type=style&index=0&id=569a810d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "569a810d",
  null
  
)

export default component.exports